export const styles = {
  container: {
    width: '100%',
    maxWidth: '730px',
  },
  textField: {
    width: '100%',
    maxWidth: '453px',
    height: '55px',
    marginTop: '40px',
  },
  submitButton: {
    width: '100%',
    maxWidth: '117px',
    height: '40px',
    margin: '40px auto 0 auto',
    padding: '8px 16px',
    fontSize: '16px',
    fontWeight: '400',
    borderRadius: '8px',
    border: 'none',
  },
  buttonForgotPassword: {
    border: 'none',
    background: 'none',
    fontSize: '16px',
    fontWeight: '400',
  },
};
